import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d22908c")

_pushScopeId("data-v-4d22908c")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "cloud-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa-solid fa-cloud-arrow-up" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    onDragenter: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"])),
    onDragleave: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"])),
    onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["prevent"])),
    class: [{ 'active-dropzone': _ctx.state.data.active }, "dropzone mb-3"]
  }, [
    _hoisted_1,
    _createVNode("span", null, _toDisplayString(_ctx.$t('drag_or_drop_files')), 1),
    _createVNode("span", null, _toDisplayString(_ctx.$t('or')), 1),
    _createVNode("label", {
      for: `dropzoneFile${_ctx.uniqueId}`
    }, _toDisplayString(_ctx.$t('select_files')), 9, ["for"]),
    _createVNode("input", {
      type: "file",
      multiple: "",
      accept: "*.*",
      id: `dropzoneFile${_ctx.uniqueId}`,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDocumentChange($event)))
    }, null, 40, ["id"])
  ], 34))
})